import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { State } from 'src/app/app.reducer';
import { Flight } from 'src/app/core/models/itinerary.model';
import { CheckAndUncheckService } from 'src/app/search-result/services/check-and-uncheck.service';
@Component({
  selector: 'app-flights',
  templateUrl: './flights.component.html',
  styleUrls: ['./flights.component.scss']
})
export class FlightsComponent implements OnInit {
  @Input() flights: Flight[];
  @Input() canSelect: boolean;
  @Input() isExchangeFlight: boolean;
  @Input() showBaggage = false;
  @Input() isInvoluntary: boolean;
  @Input() isHeader: boolean;
  @Input() associatedFlight: number;
  @Input() set mode(value: string) {
    this.deselectAll();
  }
  @Input() set checkedHide(value: boolean) {
    this.selectedHide = value;
    if (!value) {
      this.deselectAll();
    }
  }

  @Output() selectFlights = new EventEmitter<number[]>();
  @Output() selectAll = new EventEmitter<string>();
  @Output() changeClass = new EventEmitter<string>();

  selecteds: number[] = [];
  selectedHide: boolean;
  originalFlightModal = false;
  passengerCount: number;

  constructor(private helper: CheckAndUncheckService, private store: Store<State>) {}

  ngOnInit(): void {
    this.store.pipe(take(1)).subscribe((obj: State) => {
      if (obj && obj.searchResult && obj.searchResult.selectedPassengersQuote) {
        this.passengerCount = obj.searchResult.selectedPassengersQuote.filter(
          (resp) => resp.passengerType != 'infant'
        ).length;
      }
    });
  }

  over(index) {
    this.flights[index].isHovered = true;
  }

  leave(index) {
    this.flights[index].isHovered = false;
  }

  clickFlight(i) {
    if (!this.selectedHide && this.canSelect) {
      this.selecteds = this.helper.checkAndUncheck(
        this.flights[i],
        this.selecteds,
        this.flights[i].index
      );
      this.selectFlights.emit(this.selecteds);
      this.sendEventType();
    }
  }

  sendEventType() {
    if (this.areAllFlightsSelected()) {
      this.noPaint();
      this.selectAll.emit('all');
    } else if (this.selecteds.length === 0) {
      this.selectAll.emit('none');
    } else {
      this.selectAll.emit('some');
    }
  }

  areAllFlightsSelected(): boolean {
    return this.flights.length === this.selecteds.length;
  }

  noPaint() {
    this.selectedHide = true;
  }

  deselectAll() {
    this.selecteds = [];
    setTimeout(() => {
      this.flights.forEach((flight) => (flight.isChecked = false));
    });
  }

  modal(open: boolean) {
    this.originalFlightModal = open;
  }
}
